import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { crmApi, type Customer } from '../../api/crm';

export function LoyaltyDashboardPage() {
  const [customers, setCustomers] = useState<Customer[]>([]);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    void crmApi.listCustomers().then(setCustomers);
  }, []);

  async function award(id: string) {
    await crmApi.awardPoints(id, 250);
    setMsg('Points awarded');
  }

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/customers" className="text-sm text-slate-600 hover:underline">← CRM hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Loyalty dashboard</h1>
      {msg && <p className="mt-2 text-sm text-green-700">{msg}</p>}
      <ul className="mt-4 space-y-2">
        {customers.map((c) => (
          <li key={c.id}>
            <button type="button" onClick={() => void award(c.id)}
              className="rounded border px-3 py-2 text-sm">Award 250 pts — {c.customer_code}</button>
          </li>
        ))}
      </ul>
    </div>
  );
}
